/** @deprecated Import from `@cornerstonejs/metadata` instead. */
import { utilities } from '@cornerstonejs/metadata';

export default utilities.imageIdToURI;
